import { ResourceSectionCard, Stack } from '@all-manager/design-system-v2';
import ReminderCard from '../../../providers/components/ProviderDetails/ReminderCard/ReminderCard';
import { useRemindersSection } from './useRemindersSection';

export default function RemindersSection() {
  const hook = useRemindersSection();

  return (
    <ResourceSectionCard
      variant="rappel"
      title="Rappels"
      count={hook.items.length}
      isLoading={hook.isLoading}
      isEmpty={hook.items.length === 0}
      emptyLabel="Aucun rappel"
    >
      <Stack spacing={1}>
        {hook.items.map((reminder) => {
          const href = hook.getReminderHref(reminder);

          return (
            <ReminderCard
              key={reminder.id}
              reminder={reminder}
              variant="condensed"
              displayProvider
              displaySubject
              href={href}
              onClick={href ? (event) => hook.handleReminderClick(event, href) : undefined}
            />
          );
        })}
      </Stack>
    </ResourceSectionCard>
  );
}
